import useUpdateRequired from '@hooks/native/useUpdateRequired';
import { useFlow } from '@stackflow/react';
import { isForceUpdatingAtom } from '@states/uiAtoms';
import { useSetAtom } from 'jotai';

function useForceUpdate() {
    const setIsForceUpdating = useSetAtom(isForceUpdatingAtom);
    const { push } = useFlow();
    useUpdateRequired({
        onUpdateRequired: ({ storeUrl }) => {
            setIsForceUpdating(true);
            push('ForceUpdateModal', { storeUrl });
        },
    });
}

export default useForceUpdate;
